import { RootState } from 'store/store';

export const selectEntryRequests = (state: RootState) => state.entryRequests.items;
export const selectEntryRequestsLoading = (state: RootState) => state.entryRequests.isLoading;
export const selectEntryRequestsLoaded = (state: RootState) => state.entryRequests.isLoaded;
